import {mapMutations} from "vuex";

export default {
    name: 'cancel-test',
    computed: {
        route() {
            return this.$route.name.includes('home-work') ? {
                name: 'courses-dashboard',
                params: {item: this.$route.params.item}
            } : {name: 'tests'}
        }
    },
    methods: {
        ...mapMutations({
            changeShowPopup: 'tests/CHANGE_POPUP_CANCEL_TEST',
            changeHeaderHomeWork: 'coursesHomeWork/CHANGE_HEADER',
            changeHeaderTest: 'tests/CHANGE_HEADER',
        }),
        navigateTo(route) {
            try {
                this.changeShowPopup(false)
                this.changeHeaderTest({show: false, parentRoute: ''});
                this.changeHeaderHomeWork({show: false, parentRoute: ''});
                this.$router.push(this.route)
            } catch (e) {
                console.log(e);
            }
        }
    },
}
